import {TaskModuleMediaData} from '../../types/TaskModuleMediaData';

export class MediaWebsitePopupData {

    constructor(public mediaData: TaskModuleMediaData) {
    }

}
